<template>
  <el-dialog v-dialogDrag title="复制列表页" :visible.sync="dlgVisible" width="500px" :modal="false">
    <el-form :model="listPage" label-width="100px" label-position="top" :rules="rules" size="small">
      <el-form-item label="新列表名称" prop="listPageName" size="small">
        <el-input v-model="listPage.listPageName" clearable maxlength="30"
          show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="新列表编号" prop="listPageCode">
        <el-input v-model="listPage.listPageCode" clearable maxlength="30"
          show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="listPage.remark" clearable maxlength="100" type="textarea" rows="3"
          show-word-limit></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button type="default" size="small" @click="dlgVisible = false">取消</el-button>
      <el-button type="primary" size="small" @click="handleOk">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { cloneDynTableList } from '@/CommonDP/service/listFlow-service';

export default {
  data() {
    return {
      dlgVisible: false,
      listPage: {
        sourceListPageId: "",
        listPageName: "",
        listPageCode: "",
        remark: ""
      },
      rules: {
        listPageName: [{ required: true, message: ' ', trigger: 'blur' }],
        listPageCode: [{ required: true, message: ' ', trigger: 'blur' }]
      }
    };
  },

  methods: {
    show(row) {
      this.listPage.sourceListPageId = row.listPageId;
      this.listPage.listPageName = row.listPageName;
      this.listPage.listPageCode = row.listPageCode;
      this.listPage.remark = row.remark;
      this.dlgVisible = true;
    },

    async handleOk() {
      try {
        await this.$confirm("确认复制吗？");
      } catch (e) {
        return;
      }
      await cloneDynTableList(this.listPage);
      this.$success("复制成功");
      this.$emit("ok");
      this.dlgVisible = false;
    }
  }
};
</script>
